module.exports = __webpack_public_path__ + "img/order-batch-img.8b6d5aea.svg";